import useNoSearchResultsStyles from './NoSearchResults.styles';

const NoSearchResults = () => {
    const styles = useNoSearchResultsStyles();

    return (
        <div className={styles.root}>
            <div className={styles.text}>No Results Found</div>
        </div>
    );
};

export default NoSearchResults;
